module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/34906e92db0f4c33c48980bd7ccb9638.png";